import { useEffect, useState } from "react";
import WebFont from "webfontloader";
import brandFontsConfig from "utils/brandFontsConfig.json";


export default function useBrandFont(brand, defaultFont = "Hanken Grotesk, sans-serif") {
    const [fontFamily, setFontFamily] = useState(defaultFont);
    useEffect(() => {
        if (!brand || !brandFontsConfig[brand]) return;
        const theme = brandFontsConfig[brand];
        setFontFamily(theme.fontFamily);
    
        if (theme.source === "google") {
          WebFont.load({
            google: {
              families: [`${theme.fontFamily}:${(theme.weights || [400]).join(",")}`]
            }
          });
        }
        if (theme.source === "local" && theme.url) {
          const style = document.createElement("style");
          style.innerHTML = `
            @font-face {
              font-family: '${theme.fontFamily}';
              src: url('${theme.url}') format('${theme.format || "woff2"}');
              font-weight: ${theme.weights?.[0] || 400};
              font-style: normal;
            }
          `;
          document.head.appendChild(style);
        }
      }, [brand]);

    return fontFamily;
}